import { useEffect, useRef } from 'react';

import {
  buildBloxBlockTitle,
  buildBloxModelSectionTitle,
  type BloxBlockTitleMode,
} from 'utils/bloxDocumentTitle';

export function useBloxModelSectionTitle(section: string, modelName: string | undefined): void {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = buildBloxModelSectionTitle(section, modelName);
  }, [section, modelName]);

  useEffect(
    () => () => {
      document.title = defaultTitle.current;
    },
    [],
  );
}

export function useBloxBlockPageTitle(
  blockName: string | undefined,
  modelName: string | undefined,
  mode: BloxBlockTitleMode,
): void {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = buildBloxBlockTitle(blockName, modelName, mode);
  }, [blockName, modelName, mode]);

  useEffect(
    () => () => {
      document.title = defaultTitle.current;
    },
    [],
  );
}
